import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offer-for',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './offer-for.component.html',
  styleUrl: './offer-for.component.css',
})
export class OfferForComponent {
  header = input<string>();
  subheader = input<string>();
  bold1 = input<string>();
  text1 = input<string>();
  bold2 = input<string>();
  text2 = input<string>();
  bold3 = input<string>();
  text3 = input<string>();
  bold4 = input<string>();
  text4 = input<string>();
}
